import {
  ArrowRight,
  BadgeCheck,
  BrainCircuit,
  BriefcaseBusiness,
  Building2,
  CalendarClock,
  CheckCircle2,
  ChevronDown,
  ClipboardCheck,
  CloudCog,
  Code2,
  DatabaseZap,
  FileCode2,
  FileText,
  Gauge,
  Headphones,
  Home,
  Layers3,
  LifeBuoy,
  ListChecks,
  LockKeyhole,
  Mail,
  MapPin,
  Menu,
  MessageSquareText,
  Network,
  Phone,
  RadioTower,
  Send,
  ServerCog,
  ShieldCheck,
  Sparkles,
  UsersRound,
  Wifi,
  Workflow,
  X,
  type LucideIcon
} from 'lucide-react';

export const icons: Record<string, LucideIcon> = {
  arrowRight: ArrowRight,
  badgeCheck: BadgeCheck,
  brain: BrainCircuit,
  briefcase: BriefcaseBusiness,
  building: Building2,
  calendar: CalendarClock,
  check: CheckCircle2,
  chevronDown: ChevronDown,
  clipboard: ClipboardCheck,
  cloud: CloudCog,
  code: Code2,
  database: DatabaseZap,
  fileCode: FileCode2,
  fileText: FileText,
  gauge: Gauge,
  headphones: Headphones,
  home: Home,
  layers: Layers3,
  lifeBuoy: LifeBuoy,
  listChecks: ListChecks,
  lock: LockKeyhole,
  mail: Mail,
  mapPin: MapPin,
  menu: Menu,
  message: MessageSquareText,
  network: Network,
  phone: Phone,
  radio: RadioTower,
  send: Send,
  server: ServerCog,
  shield: ShieldCheck,
  sparkles: Sparkles,
  users: UsersRound,
  wifi: Wifi,
  workflow: Workflow,
  x: X
};

export function Icon({ name, className }: { name: string; className?: string }) {
  const LucideIcon = icons[name] ?? icons.check;
  return <LucideIcon className={className} aria-hidden="true" />;
}
